import { Injectable } from '@angular/core';
import { CitationChunk, CitationDetail } from 'src/app/models/AI/citation';

@Injectable({
  providedIn: 'root'
})
export class CitationService {
  // Flat map: refId → CitationChunk
  private chunkMap: { [refId: string]: CitationChunk } = {};

  parseCitations(channelData: any): void {
    if (!channelData) return;

    const data = typeof channelData === 'string' ? JSON.parse(channelData) : channelData;
    const citations = data?.citations ?? data?.Citations;
    const documents = data?.documents ?? data?.Documents;

    if (!citations || typeof citations !== 'object' || Array.isArray(citations)) return;

    // Build a documentId → title lookup from the documents map
    const titleMap: { [docId: string]: string } = {};
    if (documents && typeof documents === 'object' && !Array.isArray(documents)) {
      for (const docId of Object.keys(documents)) {
        const doc = documents[docId];
        titleMap[docId] = doc.title ?? doc.Title ?? '';
      }
    }

    // citations is an object keyed by refId
    for (const refId of Object.keys(citations)) {
      const raw = citations[refId];
      const documentId = String(raw.documentId ?? raw.DocumentId);
      this.chunkMap[refId] = {
        refId,
        documentId,
        title: raw.title ?? raw.Title ?? titleMap[documentId] ?? '',
        pageNumber: raw.pageNumber ?? raw.PageNumber ?? 1,
        searchText: raw.searchText ?? raw.SearchText ?? '',
        Source: raw.source ?? raw.Source ?? ''
      };
    }
  }

  /**
   * Look up chunk(s) by ref IDs from the cite href.
   */
  getChunksByRefIds(refIds: string[]): CitationChunk[] {
    return refIds.map(id => this.chunkMap[id]).filter(Boolean);
  }

  /**
   * Get all chunks for a given documentId.
   */
  getChunksByDocumentId(documentId: string): CitationChunk[] {
    return Object.values(this.chunkMap).filter(c => c.documentId === String(documentId));
  }

  getCitationByDocumentId(documentId: string): CitationDetail | undefined {
    const chunks = this.getChunksByDocumentId(documentId);
    if (chunks.length === 0) return undefined;
    return {
      displayIndex: 0,
      documentId: String(documentId),
      title: chunks[0].title,
      chunks
    };
  }

  getChunkMap(): { [refId: string]: CitationChunk } {
    return this.chunkMap;
  }
}
